export const es = {
  'brand.name': 'PAPO',
  'brand.full': 'Poder Africano Para Organizados',
  'brand.subtitle': 'Poder Africano',
  'brand.suffix': 'Para Organizados',
  'brand.copyright': '© 2026 PAPO: Poder Africano Para Organizados. Africa libre, Africa nuestra.',
  'landing.slogan.0': 'Donde nuestra voz no se calla \u2013 Africa libre, Africa nuestra.',
  'landing.slogan.1': 'Sin miedo, sin mordaza \u2013 por una Africa de derechos y justicia.',
  'landing.slogan.2': 'Unidos contra el regimen que nos oprime \u2013 la libertad no es un crimen.',
  'landing.slogan.3': 'Del nepotismo a la esperanza: juntos por una Africa soberana.',
  'landing.slogan.4': 'Habla, Africa! Aqui el pueblo denuncia, resiste y construye el futuro.',
  'landing.slogan.5': 'Crea tu Africa. Sin miedo, sin censura, solo talento e historias nuevas.',
  'landing.login': 'Entrar',
  'landing.register': 'Unete',
  'landing.join': 'Unete a la resistencia',
  'landing.haveAccount': 'Ya tengo cuenta',
  'landing.createAccount': 'Crear mi cuenta',
  'landing.feat.safe.title': 'Espacio Seguro',
  'landing.feat.safe.desc': 'Protegido contra la censura y la vigilancia. Tu voz, tu libertad.',
  'landing.feat.community.title': 'Comunidad Unida',
  'landing.feat.community.desc': 'Conecta con africanos organizados que luchan por la soberania y la justicia.',
  'landing.feat.resist.title': 'Denuncia y Resiste',
  'landing.feat.resist.desc': 'Reporta abusos, comparte testimonios, construye el futuro de Africa.',
  'landing.feat.privacy.title': 'Privacidad Total',
  'landing.feat.privacy.desc': 'Tus datos nunca seran vendidos. Cumplimos con la ley internacional.',
  'landing.different': 'Una red social',
  'landing.different2': 'diferente',
  'landing.differentDesc': 'Creada por y para africanos que quieren vivir libres del regimen.',
  'landing.heroCaption': 'Habla, Africa! Aqui el pueblo denuncia, resiste y construye el futuro.',
  'landing.values': 'Nuestros Valores',
  'landing.valuesTitle': 'Construyendo una Africa',
  'landing.valuesDemocratic': 'soberana',
  'landing.power.title': 'Poder al Pueblo',
  'landing.power.desc': 'Cada voz cuenta. Cada denuncia importa. Juntos somos mas fuertes.',
  'landing.transparency.title': 'Transparencia',
  'landing.transparency.desc': 'Sin algoritmos manipuladores. Sin datos vendidos. Sin censura.',
  'landing.unity.title': 'Unidad Africana',
  'landing.unity.desc': 'Un espacio inclusivo para todos los africanos que suenan con la libertad.',
  'landing.cta.title': 'La libertad no es un crimen',
  'landing.cta.desc': 'Unidos contra el regimen que nos oprime. Unete a PAPO y se parte del cambio.',
  'nav.home': 'Inicio',
  'nav.groups': 'Grupos',
  'nav.events': 'Eventos',
  'nav.messages': 'Mensajes',
  'nav.wallet': 'Cartera',
  'nav.analytics': 'Analiticas',
  'analytics.title': 'Analiticas',
  'analytics.subtitle': 'Estadisticas de interaccion y tendencias',
  'analytics.reactions': 'Reacciones',
  'analytics.comments': 'Comentarios',
  'analytics.messages': 'Mensajes',
  'analytics.profileViews': 'Visitas al perfil',
  'analytics.yourEngagement': 'Tu engagement',
  'analytics.othersEngagement': 'Engagement de otros',
  'analytics.totalOutgoing': 'Interacciones que hiciste',
  'analytics.totalIncoming': 'Interacciones que recibiste',
  'analytics.topFriends': 'Amigos mas interactivos',
  'analytics.noData': 'Sin datos de interaccion aun',
  'analytics.activityChart': 'Actividad de los ultimos 30 dias',
  'analytics.noActivity': 'Sin actividad en este periodo',
  'analytics.posts': 'Posts',
  'nav.profile': 'Mi perfil',
  'nav.settings': 'Configuracion',
  'nav.logout': 'Cerrar sesion',
  'auth.email': 'Email',
  'auth.password': 'Contrasena',
  'auth.confirmPassword': 'Confirmar contrasena',
  'auth.name': 'Nombre completo',
  'auth.login': 'Entrar',
  'auth.register': 'Crear cuenta',
  'auth.logging': 'Entrando...',
  'auth.registering': 'Creando cuenta...',
  'auth.loginTitle': 'Entra en tu cuenta',
  'auth.registerTitle': 'Crea tu cuenta',
  'auth.loginSubtitle': 'Tu voz importa. Africa te necesita.',
  'auth.registerSubtitle': 'Unete a la comunidad que esta cambiando Africa.',
  'auth.noAccount': 'No tienes cuenta?',
  'auth.haveAccount': 'Ya tienes cuenta?',
  'auth.registerLink': 'Crea una ahora',
  'auth.loginLink': 'Entra aqui',
  'auth.googleLogin': 'Continuar con Google',
  'auth.backHome': 'Volver al inicio',
  'auth.fillAll': 'Por favor completa todos los campos',
  'auth.passNoMatch': 'Las contrasenas no coinciden',
  'auth.passMin': 'La contrasena debe tener al menos 6 caracteres',
  'auth.welcomeBack': 'Bienvenido de vuelta!',
  'auth.welcome': 'Bienvenido a PAPO!',
  'auth.loginError': 'Error al iniciar sesion',
  'auth.sessionExpired': 'Tu sesión ha caducado. Vuelve a iniciar sesión.',
  'auth.registerError': 'Error al crear la cuenta',
  'dash.createPost': 'Que quieres compartir?',
  'dash.share': 'Compartir',
  'dash.myGroups': 'Mis grupos',
  'dash.seeAllGroups': 'Ver todos',
  'dash.upcomingEvents': 'Proximos eventos',
  'dash.seeAllEvents': 'Ver todos',
  'dash.members': 'miembros',
  'dash.loadError': 'Error al cargar el feed',
  'dash.releaseToRefresh': 'Suelta para actualizar',
  'groups.title': 'Grupos',
  'groups.search': 'Buscar grupos...',
  'groups.create': 'Crear grupo',
  'groups.new': 'Nuevo grupo',
  'groups.name': 'Nombre del grupo',
  'groups.description': 'Descripcion',
  'groups.category': 'Categoria',
  'groups.creating': 'Creando...',
  'groups.join': 'Unirse',
  'groups.leave': 'Salir',
  'groups.joined': 'Miembro',
  'groups.noGroups': 'No se encontraron grupos',
  'groups.loadError': 'Error al cargar los grupos',
  'groups.createError': 'Error al crear el grupo',
  'groups.created': 'Grupo creado!',
  'groups.fillAll': 'Completa todos los campos',
  'groups.joinedMsg': 'Te has unido al grupo',
  'groups.leftMsg': 'Has salido del grupo',
  'groups.cat.all': 'Todos',
  'groups.cat.general': 'General',
  'groups.cat.wellness': 'Bienestar',
  'groups.cat.mindfulness': 'Consciencia',
  'groups.cat.creativity': 'Creatividad',
  'groups.cat.support': 'Apoyo',
  'groups.cat.learning': 'Aprendizaje',
  'events.title': 'Eventos',
  'events.create': 'Crear evento',
  'events.new': 'Nuevo evento',
  'events.eventTitle': 'Titulo',
  'events.description': 'Descripcion',
  'events.date': 'Fecha',
  'events.location': 'Ubicacion',
  'events.creating': 'Creando...',
  'events.attend': 'Participar',
  'events.attending': 'Inscrito',
  'events.attendees': 'participantes',
  'events.noEvents': 'No se encontraron eventos',
  'events.loadError': 'Error al cargar los eventos',
  'events.createError': 'Error al crear el evento',
  'events.created': 'Evento creado!',
  'events.fillAll': 'Completa todos los campos obligatorios',
  'events.attendOk': 'Inscripcion confirmada!',
  'events.unattendOk': 'Ya no participaras',
  'events.attendError': 'Error al procesar la solicitud',
  'msg.title': 'Mensajes',
  'msg.search': 'Buscar usuarios...',
  'msg.typeMessage': 'Escribe un mensaje...',
  'msg.noConversations': 'Sin conversaciones',
  'msg.startChat': 'Inicia una conversacion',
  'msg.selectChat': 'Selecciona una conversacion',
  'msg.sendError': 'Error al enviar el mensaje',
  'msg.report': 'Denunciar usuario',
  'msg.block': 'Bloquear usuario',
  'search.title': 'Resultados de busqueda',
  'search.placeholder': 'Buscar...',
  'search.for': 'Resultados para',
  'search.error': 'Error en la busqueda',
  'search.all': 'Todo',
  'search.people': 'Personas',
  'search.posts': 'Publicaciones',
  'search.groups': 'Grupos',
  'search.hashtags': 'Hashtags',
  'search.searching': 'Buscando...',
  'search.results': 'resultados',
  'search.users': 'Usuarios',
  'search.posts': 'Publicaciones',
  'search.groups': 'Grupos',
  'search.events': 'Eventos',
  'search.hashtags': 'Hashtags',
  'wellness.title': 'Tu bienestar',
  'wellness.session': 'Sesion',
  'wellness.dailyUsage': 'Uso diario',
  'wellness.nearLimit': 'Estas cerca de tu limite diario. Considera tomarte un descanso.',
  'wellness.reminder': 'Las redes sociales son una herramienta, no una obligacion.',
  'wellness.takeBreak': 'Tomar un descanso',
  'wellness.breakTitle': 'Momento de pausa',
  'wellness.sessionTime': 'Tiempo de sesion',
  'wellness.minutes': 'minutos',
  'wellness.inhale': 'Inspira',
  'wellness.hold': 'Manten',
  'wellness.exhale': 'Expira',
  'wellness.notNow': 'Ahora no',
  'wellness.break5': 'Descanso 5 min',
  'wellness.restMode': 'Modo Descanso',
  'wellness.endBreak': 'Terminar descanso',
  'wellness.weeklyTitle': 'Bienestar Semanal',
  'wellness.weeklySubtitle': 'Tus últimos 7 días',
  'wellness.totalWeek': 'Total semana',
  'wellness.avgDaily': 'Promedio diario',
  'wellness.breaksTaken': 'Pausas tomadas',
  'wellness.streak': 'Días en racha',
  'wellness.currentSession': 'Sesión actual',
  'post.comment': 'Escribe un comentario...',
  'post.comments': 'comentarios',
  'post.loadComments': 'Ver comentarios',
  'post.deleteConfirm': 'Eliminar publicacion?',
  'post.report': 'Denunciar',
  'post.block': 'Bloquear',
  'post.moderation': 'Estado de moderacion',
  'post.tip': 'Propina',
  'post.delete': 'Eliminar',
  'wallet.title': 'Cartera',
  'wallet.balance': 'Saldo total',
  'wallet.send': 'Enviar',
  'wallet.receive': 'Recibir',
  'wallet.swap': 'Intercambiar',
  'wallet.stake': 'Staking',
  'wallet.transactions': 'Transacciones',
  'wallet.noTransactions': 'Sin transacciones',
  'donation.title': 'Apoyar a PAPO',
  'donation.desc': 'Tu donacion ayuda a mantener la plataforma viva e independiente.',
  'donation.copy': 'Copiar',
  'donation.copied': 'Copiado!',
  'settings.title': 'Configuracion',
  'settings.account': 'Cuenta',
  'settings.privacy': 'Privacidad',
  'settings.notifications': 'Notificaciones',
  'settings.wellness': 'Bienestar',
  'settings.theme': 'Tema',
  'settings.language': 'Idioma',
  'settings.export': 'Exportar datos',
  'settings.delete': 'Eliminar cuenta',
  'profile.followers': 'Seguidores',
  'profile.following': 'Siguiendo',
  'profile.posts': 'Publicaciones',
  'profile.follow': 'Seguir',
  'profile.suggestions': 'Sugerencias',
  'profile.noSuggestions': 'Sin sugerencias por ahora',
  'friends.addFriend': 'Agregar amigo',
  'friends.friends': 'Amigos',
  'friends.pending': 'Pendiente',
  'friends.accept': 'Aceptar',
  'friends.requestSent': 'Solicitud enviada',
  'friends.accepted': 'Ahora son amigos!',
  'friends.removed': 'Amigo eliminado',
  'friends.privateProfile': 'Perfil privado',
  'friends.privateDesc': 'Este perfil es privado. Agrega como amigo para ver sus publicaciones.',
  'friends.requests': 'Solicitudes de amistad',
  'friends.noRequests': 'Sin solicitudes pendientes',
  'suggestions.title': 'Personas que quizas conozcas',
  'suggestions.mutualFriends': 'amigos en común',
  'suggestions.fromContacts': 'De tus contactos',
  'suggestions.newOnPapo': 'Nuevo en PAPO',
  'suggestions.noSuggestions': 'Sin sugerencias por ahora',
  'suggestions.syncContacts': 'Sincronizar contactos',
  'suggestions.syncDesc': 'Encuentra amigos de tu movil en PAPO',
  'suggestions.contactsSynced': 'Contactos sincronizados',
  'suggestions.synced': 'contactos sincronizados',
  'suggestions.syncError': 'Error al sincronizar contactos',
  'suggestions.manualPrompt': 'Introduce los emails o telefonos de tus contactos separados por comas:',
  'msg.ephemeral': 'Mensaje efimero',
  'msg.ephemeralToggle': 'El mensaje desaparece tras leerse',
  'msg.ephemeralActive': 'Modo efimero activado — los mensajes desaparecen tras leerse',
  'friendRequests.title': 'Solicitudes de amistad',
  'friendRequests.nav': 'Solicitudes',
  'friendRequests.incoming': 'Recibidas',
  'friendRequests.sent': 'Enviadas',
  'friendRequests.noIncoming': 'Sin solicitudes recibidas',
  'friendRequests.noSent': 'Sin solicitudes enviadas',
  'friendRequests.noFriends': 'Aun no tienes amigos',
  'friendRequests.wantsToBeYourFriend': 'Quiere ser tu amigo',
  'friendRequests.pendingSent': 'Solicitud pendiente',
  'friendRequests.remove': 'Eliminar',
  'friends.requestRejected': 'Solicitud rechazada',
  'profile.unfollow': 'Dejar de seguir',
  'profile.edit': 'Editar perfil',
  'profile.bio': 'Bio',
  'common.loading': 'Cargando...',
  'common.now': 'ahora mismo',
  'common.save': 'Guardar',
  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.back': 'Volver',
  'common.min': 'min',
  'common.ago': 'hace',
  'pwa.install': 'Instalar App',
  'pwa.installDesc': 'Instala PAPO en tu dispositivo',
  'dash.addBio': 'Anade una bio para que otros te conozcan mejor.',
  'dash.viewProfile': 'Ver perfil',
  'dash.quickActions': 'Acciones rapidas',
  'dash.exploreGroups': 'Explorar grupos',
  'dash.viewEvents': 'Ver eventos',
  'dash.noPosts': 'Aun no hay publicaciones. Se el primero en compartir!',
  'dash.reactError': 'Error al reaccionar',
  'events.subtitle': 'Descubre experiencias que enriquecen tu vida',
  'events.noEventsDay': 'Sin eventos este día',

  // Group chat
  'groups.chat': 'Chat',
  'groups.noMessages': 'Sin mensajes aún',
  'groups.typeMessage': 'Escribe un mensaje...',
  'groups.noPosts': 'Sin publicaciones aún. ¡Comparte algo!',
  'chat.typing': 'está escribiendo...',

  // Polls
  'polls.create': 'Crear encuesta',
  'polls.question': 'Pregunta...',
  'polls.option': 'Opción',
  'polls.addOption': 'Añadir opción',
  'polls.publish': 'Publicar encuesta',
  'polls.votes': 'votos',

  // Help guide
  'help.title': 'Guía de PAPO',
  'help.subtitle': 'Todo lo que necesitas saber para usar la red social, paso a paso.',
  'help.contact': '¿Tienes dudas? Contacta con',
  'help.start': 'Empezar a usar PAPO',
  'events.upcoming': 'Proximos eventos',
  'events.past': 'Eventos pasados',
  'events.selectDate': 'Selecciona una fecha',
  'events.noEventsDesc': 'Se el primero en organizar un evento para la comunidad!',
  'events.createFirst': 'Crear el primer evento',
  'events.confirmed': 'Confirmado',
  'events.participated': 'participaron',
  'events.locationOpt': 'Ubicacion (opcional)',
  'events.titleLabel': 'Titulo del evento',
  'groups.subtitle': 'Conecta con comunidades que comparten tus intereses',
  'groups.noGroupsFilter': 'No se encontraron grupos con esos filtros',
  'groups.noGroupsDesc': 'Se el primero en crear un grupo!',
  'groups.createFirst': 'Crear el primer grupo',
  'groups.membersCount': 'miembros',
  'groups.groupNamePh': 'Ej: Africanos por la soberania',
  'groups.groupDescPh': 'De que trata tu grupo?',
  'groups.processError': 'Error al procesar la solicitud',
  'msg.you': 'Tu',
  'msg.online': 'En linea',
  'msg.today': 'Hoy',
  'notif.title': 'Notificaciones',
  'notif.empty': 'Sin notificaciones',
  'notif.emptyDesc': 'Cuando alguien interactue contigo, aparecera aqui.',
  'notif.markRead': 'Marcar como leidas',
  'notif.enableBrowser': 'Activar notificaciones',
  'notif.enabled': 'Notificaciones activadas',
  'notif.disabled': 'Notificaciones push desactivadas',
  'notif.denied': 'Notificaciones bloqueadas. Habilítalas en la configuración del navegador.',
  'notif.enablePush': 'Activar push',
  'notif.pushActive': 'Push activo',
  'notif.blocked': 'Bloqueado',
  'notif.reaction': 'reacciono a tu publicacion',
  'notif.comment': 'comento en tu publicacion',
  'notif.follow': 'empezo a seguirte',
  'notif.group': 'se unio a tu grupo',
  'post.createTitle': 'Crear publicacion',
  'post.placeholder': 'Que quieres compartir?',
  'post.posting': 'Publicando...',
  'post.publish': 'Publicar',
  'post.addImage': 'Anadir imagen',
  'report.title': 'Denunciar contenido',
  'report.reason': 'Motivo de la denuncia',
  'report.submit': 'Enviar denuncia',
  'report.success': 'Denuncia enviada. Gracias.',
  'donation.support': 'Apoyar',
  'post.share': 'Compartir',
  'post.linkCopied': 'Enlace copiado!',
  'post.commentBtn': 'Comentar',
  'admin.title': 'Panel Admin',
  'admin.reports': 'Denuncias',
  'admin.users': 'Usuarios',
  'admin.moderation': 'Moderacion',
  'admin.stats': 'Estadisticas',
  'admin.noReports': 'Sin denuncias pendientes',
  'admin.resolve': 'Resolver',
  'admin.dismiss': 'Archivar',
  'admin.totalUsers': 'Total de usuarios',
  'admin.totalPosts': 'Total de publicaciones',
  'admin.totalGroups': 'Total de grupos',
  'admin.pendingReports': 'Denuncias pendientes',
  'settings.darkMode': 'Modo oscuro',
  'settings.lightMode': 'Modo claro',
  'settings.themeAuto': 'Automatico',
  'stories.addStory': 'Agregar story',
  'stories.yourStory': 'Tu story',
  'stories.viewers': 'Vistas',
  'stories.delete': 'Eliminar',
  'stories.placeholder': 'Escribe algo...',
  'stories.create': 'Crear story',
  'stories.uploadMedia': 'Foto/Video',
  'stories.react': 'Reaccionar',
  'mention.placeholder': 'Mencionar @usuario',
  'trending.title': 'Tendencias',
  'poll.vote': 'Votar',
  'poll.votes': 'votos',
  'poll.voted': 'Votaste',
  'poll.ended': 'Finalizada',
  'poll.createPoll': 'Crear encuesta',
  'poll.question': 'Pregunta',
  'poll.option': 'Opcion',
  'poll.addOption': 'Agregar opcion',
  'poll.duration': 'Duracion (horas)',
  'groupChat.title': 'Chat del grupo',
  'groupChat.send': 'Enviar',
  'groupChat.placeholder': 'Mensaje...',
  'groupChat.empty': 'Sin mensajes todavia. Se el primero!',
  'post.deletePost': 'Eliminar publicacion',
  'post.reportContent': 'Reportar contenido',
  'post.blockUser': 'Bloquear usuario',
  'post.reactions': 'reacciones',
  'post.tips': 'propina',
  'post.tipsPlural': 'propinas',
  'post.comments': 'comentarios',
  'post.firstComment': 'Se el primero en comentar',
  'post.commentPlaceholder': 'Escribe un comentario...',
  'post.postDeleted': 'Publicacion eliminada',
  'post.postDeleteError': 'Error al eliminar publicacion',
  'post.blockSuccess': 'Usuario bloqueado',
  'post.blockError': 'Error al bloquear usuario',
  'post.copyError': 'Error al copiar',
  'post.commentError': 'Error al publicar comentario',
  'post.loadCommentsError': 'Error al cargar comentarios',
  'post.moderationWarning': 'Aviso de moderacion:',
  'post.contentHidden': 'Contenido oculto por moderacion',
  'post.publicPost': 'Publicacion publica',
  'post.groupPost': 'Publicacion en el grupo',
  'post.fileNotAllowed': 'Tipo de archivo no permitido',
  'post.writeOrAdd': 'Escribe algo o agrega un archivo',
  'post.created': 'Publicacion creada!',
  'post.createError': 'Error al crear la publicacion',
  'post.uploaded': 'subido',
  'post.formDesc': 'Formulario para crear una nueva publicacion',
  'dash.noGroups': 'No hay grupos disponibles',
  'dash.noEvents': 'No hay eventos proximos',
  'dash.conecta': 'Conecta y satisface tus necesidades',
  'dash.simbinDesc': 'Red de entretenimiento africano',
  'dash.assertiveDesc': 'Plataforma de networking profesional',
  'trending.posts': 'posts',
  'stories.photoVideoOnly': 'Solo fotos o videos',
  'stories.created': 'Story creado!',
  'stories.error': 'Error',
  'search.placeholder': 'Buscar personas, posts, grupos, #hashtags...',
  'msg.searchPeople': 'Buscar personas...',
  'msg.writePlaceholder': 'Escribe un mensaje...',
  'groups.members': 'Miembros',
  'tip.send': 'Enviar propina',
  'tip.placeholder': 'Cantidad',
  'tip.error': 'Error al enviar propina',
  'tip.amountError': 'Introduce una cantidad valida',
  'donation.title': 'Esto es solo el comienzo',
  'donation.subtitle': 'PAPO necesita tu ayuda',
  'donation.copy': 'Copiar',
  'donation.copied': 'Copiado!',
  'donation.addresses': 'Direcciones de donacion',
  'report.sent': 'Reporte enviado',
  'report.close': 'Cerrar',
  'report.minChars': 'Selecciona una categoria y describe el problema (minimo 10 caracteres)',
  'report.title': 'Denunciar contenido',
  'report.legalNote': 'Tu denuncia sera analizada conforme al Derecho Internacional y la legislacion de la UE.',
  'report.categoryLabel': 'Categoria de la denuncia',
  'report.categoryPlaceholder': 'Selecciona una categoria...',
  'report.descLabel': 'Descripcion',
  'report.descPlaceholder': 'Describe el problema en detalle (minimo 10 caracteres)...',
  'report.urgentNote': 'Si hay riesgo inmediato para la vida, contacta a los servicios de emergencia locales. Las denuncias urgentes se escalan automaticamente.',
  'report.submit': 'Enviar denuncia',
  'report.submitting': 'Enviando...',
  'report.received': 'Denuncia recibida',
  'report.priority': 'Prioridad',
  'report.urgent': 'Urgente',
  'report.standard': 'Estandar',
  'report.legalFrameworks': 'Marcos legales aplicables',
  'report.submitError': 'Error al enviar la denuncia',
  'report.cat.spam': 'Spam',
  'report.cat.harassment': 'Acoso',
  'report.cat.cyberbullying': 'Ciberacoso',
  'report.cat.threats': 'Amenazas',
  'report.cat.hate_speech': 'Discurso de odio',
  'report.cat.discrimination': 'Discriminacion',
  'report.cat.incitement_violence': 'Incitacion a la violencia',
  'report.cat.child_abuse': 'Abuso infantil',
  'report.cat.child_exploitation': 'Explotacion infantil',
  'report.cat.child_grooming': 'Grooming',
  'report.cat.human_trafficking': 'Trata de personas',
  'report.cat.sexual_exploitation': 'Explotacion sexual',
  'report.cat.terrorism': 'Terrorismo',
  'report.cat.extremism': 'Extremismo',
  'report.cat.self_harm': 'Autolesion',
  'report.cat.suicide': 'Suicidio',
  'report.cat.fraud': 'Fraude',
  'report.cat.scam': 'Estafa',
  'report.cat.doxxing': 'Doxxing',
  'report.cat.privacy_violation': 'Violacion de privacidad',
  'report.cat.misinformation': 'Desinformacion',
  'report.cat.other': 'Otro',
  'report.group.general': 'General',
  'report.group.cybercrime': 'Cibercrimen',
  'report.group.discrimination': 'Discriminacion y odio',
  'report.group.child_safety': 'Proteccion infantil',
  'report.group.trafficking': 'Trata de personas',
  'report.group.terrorism': 'Terrorismo',
  'report.group.safety': 'Seguridad personal',
  'report.group.fraud': 'Fraude',
  'search.popularTags': 'Hashtags populares',
  'search.noResults': 'Sin resultados para',
  'search.publishHashtags': 'Publica con #hashtags para que aparezcan aqui',
  'search.people': 'Personas',
  'search.membersCount': 'miembros',
  'tip.title': 'Enviar propina',
  'tip.desc': 'Apoya a {name} con una propina crypto',
  'tip.chain': 'Cadena',
  'tip.amount': 'Cantidad',
  'tip.message': 'Mensaje (opcional)',
  'tip.messagePlaceholder': 'Gran contenido!',
  'tip.sent': 'Propina enviada',
  'tip.note': 'Las propinas son simbolicas y quedan registradas en la plataforma.',
  'donation.body': 'Para mejorar y mantener nuestra comunidad segura, necesitamos apoyo financiero para protegernos legalmente y cubrir los costos de infraestructura.',
  'donation.addressCopied': 'Direccion copiada!',
  'donation.close': 'Entendido, gracias!',
  'donation.footer': 'Cada contribucion ayuda a mantener PAPO como un espacio digital seguro, libre y comprometido con el futuro de Africa.',
  'common.error': 'Error',
  'reaction.empower': 'Empoderar',
  'reaction.support': 'Apoyar',
  'reaction.inspire': 'Inspirar',
  'reaction.peace': 'Paz',
  'profile.loadError': 'Error al cargar el perfil',
  'profile.unfollowed': 'Dejaste de seguir a este usuario',
  'profile.followed': 'Ahora sigues a este usuario',
  'profile.listError': 'Error al cargar la lista',
  'profile.reactionError': 'Error al reaccionar',
  'profile.updated': 'Perfil actualizado',
  'profile.updateError': 'Error al actualizar el perfil',
  'profile.photoUpdated': 'Foto actualizada',
  'profile.photoError': 'Error al subir la imagen',
  'profile.memberSince': 'Miembro de PAPO',
  'profile.mutualFriends': 'amigos en común',
  'profile.noPosts': 'Aun no has publicado nada. Comparte algo con la comunidad!',
  'profile.noPostsOther': 'Este usuario aun no ha publicado nada.',
  'groups.catAll': 'Todos',
  'groups.catGeneral': 'General',
  'groups.catWellness': 'Bienestar',
  'groups.catMindfulness': 'Consciencia',
  'groups.catCreativity': 'Creatividad',
  'groups.catSupport': 'Apoyo',
  'groups.catLearning': 'Aprendizaje',
  'groupDetail.loadError': 'Error al cargar el grupo',
  'groupDetail.left': 'Has salido del grupo',
  'groupDetail.joined': 'Te has unido al grupo',
  'groupDetail.actionError': 'Error al procesar la solicitud',
  'groupDetail.reactionError': 'Error al reaccionar',
  'settings.tabProfile': 'Perfil',
  'settings.tabWellness': 'Bienestar',
  'settings.tabNotifications': 'Notificaciones',
  'settings.tabPrivacy': 'Privacidad',
  'settings.tabLegal': 'Legal / RGPD',
  'settings.tabAppearance': 'Apariencia',
  'settings.saved': 'Perfil actualizado',
  'settings.saveError': 'Error al guardar los cambios',
  'settings.imageTooBig': 'La imagen no puede superar 5MB',
  'settings.photoUpdated': 'Foto actualizada',
  'settings.photoError': 'Error al subir la imagen',
  'settings.deleteRequested': 'Solicitud de eliminacion registrada',
  'settings.deleteError': 'Error al solicitar eliminacion',
  'settings.deleteCancelled': 'Solicitud de eliminacion cancelada',
  'msg.blockError': 'Error al bloquear usuario',
  'msg.caller': 'Usuario',
  'msg.userNotFound': 'Usuario no encontrado',
  'msg.blockedFromMsg': 'Bloqueado desde mensajes',
  'msg.userBlocked': 'Usuario bloqueado',
  'msg.yourMessages': 'Tus mensajes',
  'msg.selectOrSearch': 'Selecciona una conversacion o busca a alguien para chatear',
  'msg.noChatsYet': 'No tienes conversaciones',
  'msg.searchToChat': 'Busca personas para iniciar un chat',
  'msg.startConvo': 'Inicia la conversacion',
  'bluetooth.papoUser': 'Usuario PAPO',
  'settings.bioPlaceholder': 'Cuentanos sobre ti...',
  'settings.save': 'Guardar cambios',
  'settings.currentSession': 'Sesion actual',
  'settings.maxDaily': 'Tiempo maximo diario',
  'settings.privacyTitle': 'Privacidad y seguridad',
  'settings.deleteAccount': 'Eliminar mi cuenta',
  'settings.cancelDelete': 'Cancelar eliminacion',
  'settings.requestDelete': 'Solicitar eliminacion de cuenta',
  'settings.deleteConfirmTitle': 'Eliminar cuenta permanentemente',
  'settings.cancel': 'Cancelar',
  'settings.exportError': 'Error al exportar datos',
  'settings.title': 'Configuracion',
  'settings.logout': 'Cerrar sesion',
  'settings.profileInfo': 'Informacion del perfil',
  'settings.nameLabel': 'Nombre',
  'settings.wellnessConfig': 'Configuracion de bienestar digital',
  'settings.exportData': 'Exportar mis datos',
  'settings.legalInfo': 'Informacion legal',
  'settings.dpo': 'Delegado de proteccion de datos',
  'settings.themeLabel': 'Tema',
  'settings.themeApplied': 'Tema aplicado',
  'settings.exportSuccess': 'Datos exportados correctamente',

  // Account Management
  'account.title': 'Gestión de cuenta',
  'account.subtitle': 'Protección de datos y privacidad (RGPD)',
  'account.exportTitle': 'Descargar mis datos',
  'account.exportDesc': 'Descarga todas tus publicaciones, mensajes, contactos y datos en un archivo ZIP comprimido. Derecho de portabilidad (RGPD Art. 20).',
  'account.exportSuccess': 'Datos descargados',
  'account.exportError': 'Error al exportar datos',
  'account.exporting': 'Generando...',
  'account.downloadZip': 'Descargar ZIP',
  'account.deactivateTitle': 'Desactivar cuenta',
  'account.deactivateDesc': 'Tu perfil dejará de ser visible para otros usuarios. Si vuelves a iniciar sesión, tu cuenta se reactivará automáticamente.',
  'account.deactivateBtn': 'Desactivar mi cuenta',
  'account.deactivateConfirmTitle': '¿Desactivar tu cuenta?',
  'account.deactivateConfirmDesc': 'Tu perfil dejará de ser visible para otros usuarios. No podrás iniciar sesión hasta que la cuenta sea reactivada. Tus datos se conservarán.',
  'account.deactivateConfirm': 'Sí, desactivar',
  'account.deactivated': 'Cuenta desactivada',
  'account.deleteTitle': 'Eliminar cuenta permanentemente',
  'account.deleteDesc': 'Elimina toda tu información de forma irreversible después de 30 días de gracia. Derecho al olvido (RGPD Art. 17). Puedes cancelar durante el período de gracia.',
  'account.deleteBtn': 'Eliminar mi cuenta',
  'account.deleteConfirmTitle': '¿Eliminar tu cuenta permanentemente?',
  'account.deleteConfirmDesc1': 'Esta acción es irreversible. Después de 30 días se eliminarán:',
  'account.deleteItem1': 'Tu perfil e información personal',
  'account.deleteItem2': 'Todas tus publicaciones y comentarios',
  'account.deleteItem3': 'Tus mensajes y conversaciones',
  'account.deleteItem4': 'Membresías de grupos y contactos',
  'account.deleteConfirmDesc2': 'Te recomendamos descargar tus datos antes de eliminar la cuenta.',
  'account.deleteConfirm': 'Eliminar en 30 días',
  'account.deleteScheduled': 'Eliminación programada para 30 días',
  'account.deletionPending': 'Eliminación programada',
  'account.deletionDate': 'Fecha:',
  'account.cancelDeletion': 'Cancelar eliminación',
  'account.deletionCancelled': 'Eliminación cancelada',
  'account.error': 'Error al procesar',
  'account.legalNotice': 'Tus derechos de protección de datos están garantizados según el Reglamento General de Protección de Datos (RGPD). Para cualquier consulta: dpo@papo.social',

  // Privacy / Visibility
  'privacy.visibility': 'Visibilidad',
  'privacy.public': 'Público',
  'privacy.private': 'Privado (solo contactos)',
  'privacy.hidden': 'Oculto',
  'privacy.inviteContacts': 'Invitar contactos',
  'privacy.searchContact': 'Buscar contacto...',
  'privacy.noContacts': 'Sin contactos',
  'settings.username': 'Nombre de usuario',
  'settings.usernameDesc': 'Un alias público que otros podrán ver en lugar de tu nombre real.',
  'settings.showEmail': 'Mostrar email en perfil',
  'settings.showEmailDesc': 'Permite que otros usuarios vean tu email en tu perfil.',
  'settings.profileVisible': 'Perfil visible',
  'settings.profileVisibleDesc': 'Ocultar tu perfil de búsquedas y visitas. Otros no podrán encontrarte.',
  'settings.saved': 'Guardado',
  'settings.save': 'Guardar',

  // Tooltips
  'profile.followersTooltip': 'Personas que siguen este perfil',
  'profile.followingTooltip': 'Personas que sigue este perfil',
  'profile.friendsTooltip': 'Amistades mutuas',
  'profile.mutualTooltip': 'Amigos que tienen en común',
  'friends.removeFriendTooltip': 'Eliminar amistad',
  'friends.pendingTooltip': 'Solicitud enviada, esperando respuesta',
  'friends.acceptTooltip': 'Aceptar solicitud de amistad',
  'friends.addFriendTooltip': 'Enviar solicitud de amistad',
  'suggestions.friendOfFriend': 'Amigo de tus amigos',
  'settings.downloadBtn': 'Descargar mis datos',
  'settings.wellnessIntro': 'PAPO te ayuda a mantener un uso saludable de las redes sociales.',
  'settings.breakReminders': 'Recordatorios de descanso',
  'settings.breakInterval': 'Intervalo de descanso',
  'settings.dailyLimit': 'Limite diario de uso',
  'settings.breakSound': 'Sonido suave al sugerir descansos',
  'settings.breakModeInfo': 'Sobre el modo descanso: Cuando se activa, veras un ejercicio de respiracion guiado con animaciones relajantes. Puedes terminar el descanso en cualquier momento.',
  'settings.notifReactions': 'Reacciones',
  'settings.notifComments': 'Comentarios',
  'settings.notifFollowers': 'Nuevos seguidores',
  'settings.notifMessages': 'Mensajes',
  'settings.notifMentions': 'Menciones',
  'settings.notifGroups': 'Actividad de grupos',
  'settings.pushNotif': 'Notificaciones push',
  'settings.pushNotifDesc': 'Recibir notificaciones en el navegador',
  'settings.enablePush': 'Activar notificaciones push',
  'settings.disablePush': 'Desactivar notificaciones push',
  'settings.publicProfile': 'Perfil publico',
  'settings.publicProfileDesc': 'Cualquiera puede ver tu perfil',
  'settings.showOnline': 'Mostrar estado en linea',
  'settings.showLastSeen': 'Mostrar ultima visita',
  'settings.blockedUsers': 'Usuarios bloqueados',
  'settings.blockedNone': 'No tienes usuarios bloqueados',
  'settings.unblock': 'Desbloquear',
  'settings.legalCommitment': 'Cumplimos con el RGPD, la Ley de Servicios Digitales (DSA), la Convencion de los Derechos del Nino, el Protocolo de Palermo, la Convencion de Budapest y las resoluciones del Consejo de Seguridad de la ONU.',
  'settings.legalCommitmentTitle': 'Compromiso legal de PAPO:',
  'settings.notifReactionsDesc': 'Cuando alguien reacciona a tus publicaciones',
  'settings.notifCommentsDesc': 'Cuando alguien comenta en tus publicaciones',
  'settings.notifMessagesDesc': 'Cuando recibes un mensaje nuevo',
  'settings.notifEvents': 'Eventos',
  'settings.notifEventsDesc': 'Recordatorios de eventos proximos',
  'settings.notifGroupsDesc': 'Nuevas publicaciones en tus grupos',
  'settings.wellnessTip': 'Consejo de bienestar:',
  'settings.wellnessTipText': 'Limitar las notificaciones puede ayudarte a reducir la ansiedad digital y mejorar tu concentracion.',
  'settings.privacyIntro': 'Tu privacidad es nuestra prioridad. PAPO nunca vendera tus datos.',
  'settings.publicProfileDesc2': 'Otros usuarios pueden ver tu perfil',
  'settings.showOnlineDesc': 'Otros ven cuando estas conectado',
  'settings.allowDM': 'Permitir mensajes directos',
  'settings.allowDMDesc': 'Cualquier persona puede enviarte mensajes',
  'settings.privacyCommitTitle': 'Compromiso PAPO:',
  'settings.privacyCommitText': 'Tus datos personales nunca seran vendidos ni utilizados para publicidad. Solo los usamos para mejorar tu experiencia.',
  'settings.legalTitle': 'Derechos legales y proteccion de datos',
  'settings.legalIntro': 'PAPO cumple con el RGPD, la Ley de Servicios Digitales de la UE y el Derecho Internacional Publico.',
  'settings.legalExportDesc': 'Descarga una copia completa de todos tus datos personales: perfil, publicaciones, comentarios, mensajes, grupos y reacciones.',
  'settings.exporting': 'Exportando...',
  'settings.legalDeleteDesc': 'Tu cuenta sera eliminada permanentemente despues de 30 dias. Todos tus datos seran eliminados.',
  'settings.deleteWarning': 'Estas seguro? Esta accion es irreversible. Tu cuenta y todos tus datos seran eliminados permanentemente.',
  'settings.deleteConfirm': 'Eliminar permanentemente',
  'settings.euRep': 'Representante UE',
  'settings.disputes': 'Resolucion de disputas',
  'settings.odrEU': 'ODR de la UE',
  'settings.transparencyReport': 'Informe de transparencia',
  'settings.viewReport': 'Ver informe',
  'settings.aiModeration': 'Moderacion IA',
  'settings.aiModDesc': 'El contenido se analiza automaticamente por IA',
  'settings.analyzed': 'Analizados',
  'settings.approved': 'Aprobados',
  'settings.warned': 'Advertidos',
  'settings.hidden': 'Ocultos/Escalados',
  'settings.loadingStats': 'Cargando estadisticas...',
  'settings.dailyUsage': 'Uso diario',
  'settings.breakDesc': 'Sugerir pausas despues de un tiempo de uso',
  'settings.breakEvery': 'Sugerir pausa cada {min} minutos',
  'settings.dailyLimitDesc': 'Recibir alerta al acercarse al limite',
  'settings.alertAt': 'Alerta al alcanzar {min} minutos',
  'settings.wellnessSounds': 'Sonidos de bienestar',
  'settings.notifTitle': 'Preferencias de notificaciones',
  'settings.notifDesc': 'Configura que notificaciones quieres recibir para un uso saludable de la plataforma.',
  'settings.appearanceTitle': 'Apariencia',
  'settings.appearanceDesc': 'Personaliza como se ve PAPO para ti.',
  'settings.appearanceTip': 'Consejo: Todos los temas estan optimizados para una lectura prolongada y el modo Oscuro reduce la emision de luz azul.',
  'settings.saving': 'Guardando...',
  'settings.hours': 'horas',
  'theme.light': 'Claro',
  'theme.dark': 'Oscuro',
  'theme.midnight': 'Medianoche',
  'theme.resistance': 'Resistencia',
  'settings.cancelError': 'Error al cancelar solicitud',
  'settings.userUnblocked': 'Usuario desbloqueado',
  'settings.unblockError': 'Error al desbloquear usuario',
  'settings.accountWillDelete': 'Tu cuenta se eliminara el {date}.',
  'settings.blockedOn': 'Bloqueado el {date}',
  'settings.bioLabel': 'Bio',
  'wallet.loadError': 'Error al cargar la cartera',
  'wallet.demoFunded': 'Cartera demo financiada',
  'wallet.fundError': 'Error al financiar',
  'wallet.sendError': 'Error en la transferencia',
  'wallet.swapError': 'Error en el swap',
  'wallet.stakeError': 'Error en el staking',
  'wallet.unstakeError': 'Error',
  'wallet.metamaskNotFound': 'MetaMask no detectado. Instala la extension.',
  'wallet.metamaskConnected': 'MetaMask conectado',
  'wallet.metamaskError': 'Error al conectar MetaMask',
  'wallet.tabPortfolio': 'Portfolio',
  'wallet.tabMarket': 'Mercado',
  'wallet.tabHistory': 'Historico',
  'wallet.tabStaking': 'Staking',
  'wallet.emptyWallet': 'Tu cartera esta vacia',
  'wallet.fundDemo': 'Financiar cartera demo',
  'wallet.activeStaking': 'Staking activo',
  'wallet.withdraw': 'Retirar',
  'wallet.availableStaking': 'Disponible para staking',
  'wallet.upToAPY': 'Hasta {apy}% APY',
  'wallet.bricsBanner': 'Pagos QR multi-pais BRICS+ — 600+ criptomonedas',
  'wallet.sendCrypto': 'Enviar crypto',
  'wallet.sendDesc': 'Transferencia P2P entre usuarios PAPO',
  'wallet.cryptocurrency': 'Criptomoneda',
  'wallet.selectPlaceholder': 'Seleccionar...',
  'wallet.available': 'disponible',
  'wallet.recipientId': 'ID del destinatario',
  'wallet.amount': 'Cantidad',
  'wallet.noteOptional': 'Nota (opcional)',
  'wallet.sending': 'Enviando...',
  'wallet.sendBtn': 'Enviar',
  'wallet.sentTo': 'Enviado a {name}',
  'wallet.receivedFrom': 'Recibido de {name}',
  'wallet.swapDesc': 'Intercambiar criptomonedas — 0.3% comision',
  'wallet.from': 'De',
  'wallet.to': 'A',
  'wallet.youWillReceive': 'Recibiras',
  'wallet.rate': 'Tasa',
  'wallet.swapping': 'Intercambiando...',
  'wallet.confirmSwap': 'Confirmar swap',
  'wallet.stakeDesc': 'Gana rendimiento sobre tus criptomonedas',
  'wallet.annualYield': 'Rendimiento anual estimado',
  'wallet.stakingProgress': 'Haciendo staking...',
  'wallet.confirmStaking': 'Confirmar staking',
  'wallet.noTransactionsYet': 'Sin transacciones aun',
  'wallet.inspired': 'Inspirada en',
  'profile.noPhotos': 'Aun no tienes fotos. Comparte imagenes con la comunidad!',
  'profile.noPhotosOther': 'Este usuario aun no ha compartido imagenes.',
  'profile.editTitle': 'Editar perfil',
  'profile.nameLabel': 'Nombre',
  'profile.bioLabel': 'Bio',
  'profile.bioPlaceholder': 'Cuentanos sobre ti...',
  'profile.saveChanges': 'Guardar cambios',
  'profile.searchByName': 'Buscar por nombre',
  'profile.noMutual': 'Sin amigos en común',
  'profile.mutualTitle': 'Amigos en común',
  'profile.followBack': "Seguir de vuelta",
  'profile.followsYou': "Te sigue",
  'profile.peopleYouMayKnow': "Personas que quizás conozcas",
  'profile.mutualFriend': "amigo en común",
  'search.recent': "Búsquedas recientes",
  'search.clearAll': "Borrar todo",
  'notif.view': "Ver",
  'search.discover': "Buscar",
  'onboarding.skip': 'Saltar',
  'onboarding.prev': 'Anterior',
  'onboarding.next': 'Siguiente',
  'onboarding.finish': '¡Empezar!',
  'onboarding.home.title': 'Inicio',
  'onboarding.home.desc': 'Tu feed: publicaciones de amigos y personas que sigues, ordenadas según con quién interactúas más.',
  'onboarding.explore.title': 'Explorar',
  'onboarding.explore.desc': 'Descubre publicaciones, reels y temas nuevos más allá de tu círculo.',
  'onboarding.messages.title': 'Mensajes',
  "onboarding.messages.desc": "Chatea en privado en tiempo real, con voz y videollamadas. Mantén pulsado un mensaje para reaccionar o pulsa ↩ para responderlo.",
  'onboarding.lives.title': 'Lives',
  "onboarding.lives.desc": "Mira directos o emite el tuyo, recibe regalos y usa emojis y stickers afro en el chat.",
  'onboarding.wallet.title': 'Wallet',
  'onboarding.wallet.desc': 'Tu billetera multichain: consulta saldos, envía y recibe cripto y propinas.',
  'onboarding.search.title': 'Buscar',
  'onboarding.search.desc': 'Encuentra personas, publicaciones, grupos y hashtags. Tus búsquedas recientes se guardan aquí.',
  'onboarding.notifications.title': 'Notificaciones',
  'onboarding.notifications.desc': 'Aquí verás al instante reacciones, comentarios, seguidores y solicitudes.',
  'onboarding.wellness.title': 'Bienestar',
  'onboarding.wellness.desc': 'Controla tu tiempo de uso diario y tómate un descanso cuando lo necesites.',
  'onboarding.profile.title': 'Perfil',
  "onboarding.profile.desc": "Edita tu perfil y mira tus seguidores. En este menú encontrarás la Guía de PAPO y las novedades.",
  'landing.slides.kicker': 'Todo lo que puedes hacer',
  'landing.slides.heading': 'Descubre PAPO, función a función',
  'landing.slides.feed.title': 'Feed inteligente',
  'landing.slides.feed.desc': 'Tu inicio aprende con quién interactúas más y te muestra primero lo que de verdad te importa de amigos y personas que sigues.',
  'landing.slides.wellness.title': 'Bienestar digital',
  'landing.slides.wellness.desc': 'Temporizador de uso, límite diario y pausas guiadas para que la red social te sume tiempo de vida, no te lo quite.',
  'landing.slides.lives.title': 'Lives con invitados',
  'landing.slides.lives.desc': 'Emite en directo, invita a otra persona a pantalla compartida y recibe reacciones y propinas en tiempo real.',
  'landing.slides.offline.title': 'Mensajes sin internet',
  'landing.slides.offline.desc': 'Comunícate por Bluetooth de teléfono a teléfono cuando no hay cobertura: ideal para zonas rurales y emergencias.',
  'landing.slides.stickers.title': 'Stickers afrocéntricos',
  'landing.slides.stickers.desc': 'Expresa tu identidad con stickers animados inspirados en las culturas africanas, del Sahel al Atlas y al Cabo.',
  'landing.slides.wallet.title': 'Wallet multichain',
  'landing.slides.wallet.desc': 'Guarda, envía y recibe cripto en varias redes, y apoya a creadores con propinas directas.',
  'landing.slides.privacy.title': 'Privacidad primero',
  'landing.slides.privacy.desc': 'Tus datos son tuyos: perfiles privados, bloqueo, denuncias y cumplimiento estricto de la protección de datos.',
  'landing.slides.groups.title': 'Grupos y eventos',
  'landing.slides.groups.desc': 'Crea comunidades, organiza encuentros y celebra con tu gente, en línea y en persona.',
  'landing.slides.explore.title': 'Buscar y Explorar',
  'landing.slides.explore.desc': 'Encuentra personas, publicaciones, grupos y hashtags en tendencia, con filtros y búsquedas recientes.',
  'landing.slides.languages.title': '4 idiomas y tema dual',
  'landing.slides.languages.desc': 'PAPO habla portugués, inglés, español y francés, con modo claro y oscuro a tu gusto.',
  'landing.slides.try': 'Pruébalo',
  'landing.demo.feed': 'Tu feed',
  'landing.demo.react': 'Reacciones',
  'landing.demo.live': 'En directo',
  'landing.demo.chat': 'Mensajes',
  'landing.demo.guest': 'Invitada',
  'landing.demo.msg1': '¿Llegaste bien a Tamanrasset?',
  'landing.demo.msg2': '¡Sí! Sin cobertura, pero PAPO funciona por Bluetooth 🙌🏽',
  'landing.demo.offline': 'Enviado sin internet',
  'testimonials.kicker': 'Voces de la comunidad',
  'testimonials.heading': 'De Dakar al Atlas, esto dice nuestra gente',
  'testimonials.formTitle': 'Comparte tu experiencia',
  'testimonials.formDesc': 'Cuéntanos qué significa PAPO para ti. Si el equipo lo aprueba, aparecerá en la página principal con tu nombre y ciudad.',
  'testimonials.quote': 'Tu testimonio',
  'testimonials.quotePlaceholder': 'Mínimo 20 caracteres...',
  'testimonials.city': 'Ciudad',
  'testimonials.country': 'País',
  'testimonials.submit': 'Enviar testimonio',
  'testimonials.update': 'Actualizar testimonio',
  'testimonials.delete': 'Eliminar',
  'testimonials.sent': '¡Gracias! Tu testimonio está en revisión',
  'testimonials.status.pending': 'En revisión',
  'testimonials.status.approved': 'Aprobado',
  'testimonials.status.rejected': 'Rechazado',
  'testimonials.status.all': 'Todos',
  'testimonials.adminTab': 'Testimonios',
  'testimonials.approve': 'Aprobar',
  'testimonials.reject': 'Rechazar',
  'testimonials.none': 'No hay testimonios aquí',
  'settings.tabCommunity': 'Comunidad y ayuda',
  'settings.replayGuide': 'Ver guía de nuevo',
  'settings.replayGuideDesc': 'Repite el recorrido por los botones principales de PAPO cuando quieras.',
  'settings.replayGuideBtn': 'Ver guía',
  'admin.signupSources': 'Registros por función (Pruébalo)',
  'admin.noSignupSources': 'Aún no hay registros desde el carrusel',
  'auth.regNamePh': 'Tu nombre',
  'auth.regEmailPh': 'tu@email.com',
  'auth.regPassPh': 'Mínimo 6 caracteres',
  'auth.regConfirmPh': 'Repite tu contraseña',
  'auth.regOrWith': 'o regístrate con',
  'upload.optimized': 'Foto optimizada',
  'stream.share': 'Compartir',
  'stream.shareTitle': 'Compartir live',
  'stream.shareText': '¡Únete a mi live en PAPO!',
  'stream.searchPeople': 'Buscar amigos y personas que sigues',
  'stream.noPeople': 'No hay personas para mostrar',
  'stream.sendTo': 'Enviar',
  'stream.sharedWith': 'Live enviado a',
  'stream.copyLink': 'Copiar enlace',
  'stream.linkCopied': '¡Enlace copiado!',
  'stream.more': 'Más',
  'stream.tapForSound': 'Toca para activar el sonido',
  'stream.ended': 'Este live ya terminó',
  'stream.removeGuest': 'Quitar invitado',
  'stream.youWereRemoved': 'El host te ha quitado del live',
  'stream.guestsFull': 'El live ya tiene 4 invitados',
  'stream.weakConnection': 'Tu conexión es débil: el vídeo puede cortarse',
  'stream.quality.good': 'Conexión buena',
  'stream.quality.fair': 'Conexión regular',
  'stream.quality.poor': 'Conexión mala',
  'stream.latency': 'Latencia',
  'stream.packetLoss': 'Pérdida de paquetes',
  'stream.cover': 'Portada (opcional)',
  'stream.coverHint': 'Se verá al compartir el enlace en WhatsApp o Facebook',
  'stream.notifyFollowers': 'Avisar a mis seguidores',
  'stream.followersNotified': 'Seguidores avisados',
  'stream.followersAlreadyNotified': 'Ya avisaste a tus seguidores en este live',
  'stream.askToJoin': 'Pedir subir',
  'stream.cancelRequest': 'Cancelar',
  'stream.joinRequests': 'Solicitudes',
  'stream.wantsToJoin': 'quiere subir al live',
  'stream.requestRejected': 'El host rechazó tu solicitud. Podrás pedirlo de nuevo en 30 s',
  'stream.accept': 'Aceptar',
  'stream.reject': 'Rechazar',
  'stream.liveNow': 'En directo',
  'profile.noFollowers': 'Sin seguidores aun',
  'profile.notFollowing': 'No sigue a nadie aun',
  'profile.reactions': 'reacciones',
  'profile.gallery': 'Galeria',
  'profile.whatToShare': 'Que quieres compartir, {name}?',
  'post.video': 'Video',
  'post.photo': 'Foto',
  'post.link': 'Enlace',
  'videoCall.connecting': 'Conectando...',
  'videoCall.ringing': 'Llamando...',
  'videoCall.media': 'Permite el acceso al micrófono para llamar.',
  'videoCall.connection': 'Se perdió la conexión. Intenta llamar de nuevo.',
  'videoCall.timeout': 'No hubo respuesta. Inténtalo más tarde.',
  'videoCall.rejected': 'La llamada fue rechazada o la persona está ocupada.',
  'videoCall.ended': 'Llamada finalizada',
  'bluetooth.enable': 'Activar',
  'bluetooth.disable': 'Desactivar',
  'bluetooth.searchPeers': 'Busca pares cercanos para conectar',
  'bluetooth.noMessages': 'Sin mensajes aun. Envia el primero!',
  'bluetooth.panicTitle': 'Modo panico - Eliminar todos los datos',
  'bluetooth.tagline': 'Sin internet - Sin censura - Cifrado de extremo a extremo',
  'bluetooth.nearbyPeers': 'Pares cercanos',
  'groups.joinToPost': 'Unete al grupo para ver y crear publicaciones.',
  'auth.authError': 'Error de autenticacion',
  'stream.title': 'Streaming en vivo',
  'stream.subtitle': 'Transmisiones en vivo de la comunidad PAPO',
  'stream.category': 'Categoria',
  'stream.allLives': 'Todas',
  'stream.cat.general': 'General',
  'stream.cat.music': 'Musica',
  'stream.cat.talk': 'Charla',
  'stream.cat.gaming': 'Juegos',
  'stream.cat.cooking': 'Cocina',
  'stream.cat.education': 'Educacion',
  'stream.cat.fitness': 'Fitness',
  'stream.cat.culture': 'Cultura',
  'stream.goLive': 'Ir en vivo',
  'stream.goLiveDesc': 'Inicia una transmision en vivo para la comunidad',
  'stream.titleLabel': 'Titulo',
  'stream.titlePlaceholder': 'Dale un titulo a tu transmision...',
  'stream.descLabel': 'Descripcion',
  'stream.descPlaceholder': 'De que vas a hablar?',
  'stream.privacy': 'Privacidad',
  'stream.public': 'Publico',
  'stream.private': 'Privado',
  'stream.startStreaming': 'Comenzar a transmitir',
  'stream.createError': 'Error al crear la transmision',
  'stream.end': 'Terminar',
  'stream.guestJoined': 'se unio al live!',
  'stream.guestDeclined': 'rechazo la invitacion',
  'stream.guestInviteTitle': 'Unirse al Live',
  'stream.guestInviteDesc': 'El anfitrion te invita a participar con tu camara y microfono. Todos los espectadores te veran y escucharan.',
  'stream.guestAccepted': 'Te uniste al live! Tu camara esta activa.',
  'stream.joinLive': 'Unirse al Live',
  'stream.decline': 'Rechazar',
  'stream.leaveGuest': 'Salir del Live',
  'stream.guests': 'invitados',
  'stream.you': 'Tu',
  'stream.liveChat': 'Chat en vivo',
  'stream.chatPlaceholder': 'Escribe un mensaje...',
  'stream.sendTip': 'Enviar propina',
  'stream.tipSent': 'Propina enviada!',
  'stream.tipped': 'dio propina de',
  'stream.inviteCohost': 'Invitar co-anfitrion',
  'stream.cohostInvited': 'Co-anfitrion invitado!',
  'stream.searchUser': 'Buscar usuario...',
  'stream.noStreams': 'No hay transmisiones en vivo',
  'stream.beFirst': 'Se el primero en ir en vivo!',
  'stream.notFound': 'Transmision no encontrada',
  'stream.hasEnded': 'La transmision ha terminado',
  'stream.cameraError': 'Error al acceder a la camara',
  // Screen Share
  'stream.screenShare': 'Compartir pantalla',
  'stream.screenShareStarted': 'Pantalla compartida iniciada',
  'stream.screenShareError': 'Error al compartir pantalla',
  // Story Highlights
  'highlights.title': 'Destacados',
  'highlights.added': 'Agregado a destacados!',
  'highlights.removed': 'Eliminado de destacados',
  'highlights.story': 'Destacado',
  'highlights.remove': 'Eliminar',
  // Post Scheduling
  'post.schedule': 'Programar',
  'post.scheduleFor': 'Programar para',
  'post.willPublishAt': 'Se publicara en',
  'post.scheduled': 'Publicacion programada!',
  'post.scheduleBtn': 'Programar',
  'post.scheduledLabel': 'Programado',
  // Post Preview
  'post.previewTitle': 'Vista previa del post',
  // Highlight Albums
  'albums.new': 'Nuevo',
  'albums.create': 'Crear album',
  'albums.edit': 'Editar album',
  'albums.save': 'Guardar',
  'albums.delete': 'Eliminar',
  'albums.created': 'Album creado!',
  'albums.updated': 'Album actualizado!',
  'albums.deleted': 'Album eliminado!',
  'albums.empty': 'No hay historias en este album',
  'albums.nameLabel': 'Nombre del album',
  'albums.namePlaceholder': 'Ej: Viajes, Momentos...',
  'albums.selectStories': 'Seleccionar historias',
  'albums.noHighlights': 'Marca historias como destacadas primero',
  // Annotations
  'annotations.pen': 'Lapiz',
  'annotations.text': 'Texto',
  'annotations.rect': 'Rectangulo',
  'annotations.arrow': 'Flecha',
  'annotations.eraser': 'Borrador',
  'annotations.clear': 'Limpiar todo',
  'annotations.enterText': 'Escribe el texto:',
  // Explore
  'explore.title': 'Explorar',
  'explore.subtitle': 'Publicaciones de amigos de amigos',
  'explore.all': 'Todo',
  'explore.photos': 'Fotos',
  'explore.videos': 'Videos',
  'explore.empty': 'Aun no hay contenido multimedia',
  'explore.emptyFeed': 'Nada que explorar aun',
  'explore.emptyFeedDesc': 'Agrega mas amigos para descubrir publicaciones de amigos de amigos',
  'explore.loadMore': 'Cargar mas',
  'explore.loading': 'Cargando...',
  // Theme toggle
  'nav.explore': 'Explorar',
  'nav.darkMode': 'Modo oscuro',
  'nav.lightMode': 'Modo claro',
  // Music
  'music.selectTrack': 'Seleccionar musica',
  'music.search': 'Buscar musica...',
  'music.addMusic': 'Agregar musica',
  'stickers.title': 'Stickers',
  'stickers.placed': 'stickers',
  'stickers.power': 'Poder',
  'stickers.culture': 'Cultura',
  'stickers.nature': 'Naturaleza',
  'stickers.food': 'Comida',
  'stickers.unity': 'Unidad',
  // Post Analytics
  'post.analytics': 'Estadisticas',
  'post.analyticsTitle': 'Analisis del post',
  'post.views': 'Vistas',
  'post.shares': 'Compartidos',
  'post.linkCopied': 'Enlace copiado!',
  'post.reactions': 'Reacciones',
  // Explore Reels
  'explore.reels': 'Reels',
  'explore.viewAll': 'Ver todos',
  // Voice Messages
  'voice.voiceMessage': 'Mensaje de voz',
  'voice.sendError': 'Error al enviar mensaje de voz',
  'voice.micError': 'Error al acceder al microfono',
  "gifts.title": "Enviar regalo",
  "gifts.send": "Enviar",
  "gifts.balance": "Saldo",
  "gifts.coins": "monedas PAPO",
  "gifts.payWithCoins": "Monedas",
  "gifts.payWithCrypto": "Cartera cripto",
  "gifts.commissionNote": "Cada regalo incluye una comisión del 0,99% para PAPO.",
  "gifts.cryptoNote": "1 moneda = 0,01 USD, se cobra de tu cartera.",
  "gifts.sent": "¡Regalo enviado!",
  "gifts.insufficient": "Saldo insuficiente",
  "gifts.sentBy": "{name} envió {gift}",
  "gifts.earnings": "Regalos recibidos",
  "gifts.earningsDesc": "Convierte las monedas de tus regalos en una propina registrada en tu saldo.",
  "gifts.convert": "Convertir en propina",
  "gifts.converted": "{n} monedas convertidas en propina",
  "gifts.noEarnings": "Aún no tienes regalos para convertir",
  "gifts.djembe": "Djembé",
  "gifts.kente": "Kente",
  "gifts.sankofa": "Sankofa",
  "gifts.baobab": "Baobab",
  "gifts.mask": "Máscara",
  "gifts.amazigh": "Yaz Amazigh",
  "gifts.lion": "León",
  "gifts.crown": "Corona",
  "mods.title": "Moderadores",
  "mods.desc": "Elige hasta 3 amigos o personas que sigues para moderar el chat.",
  "mods.search": "Buscar amigos",
  "mods.add": "Nombrar",
  "mods.remove": "Quitar",
  "mods.limit": "Máximo 3 moderadores",
  "mods.none": "No hay amigos ni seguidos para mostrar",
  "mods.granted": "{name} te nombró moderador de su live",
  "mods.deleteMsg": "Borrar mensaje",
  "mods.muteChat": "Silenciar en el chat",
  "mods.unmuteChat": "Permitir chat",
  "mods.kick": "Expulsar del live",
  "mods.kickConfirm": "¿Expulsar a {name} de este live?",
  "mods.userKicked": "{name} fue expulsado",
  "mods.kicked": "Has sido expulsado de este live",
  "mods.youAreMuted": "Un moderador te silenció en el chat",
  "mods.youAreUnmuted": "Ya puedes volver a escribir en el chat",
  "sched.schedule": "Programar para más tarde",
  "sched.create": "Programar live",
  "sched.created": "Live programado. Tus seguidores podrán activar un recordatorio.",
  "sched.invalidDate": "Elige una fecha futura (máx. 30 días)",
  "sched.upcoming": "Próximamente",
  "sched.remind": "Recordarme",
  "sched.reminded": "Te avisaremos",
  "sched.remindOn": "Te avisaremos 10 min antes y al empezar",
  "sched.startNow": "Empezar ahora",
  "sched.cancel": "Cancelar",
  "sched.cancelConfirm": "¿Cancelar este live programado?",
  "sched.cancelled": "Live programado cancelado",
  "admin.commissions": "Comisiones",
  "admin.commissionsCoins": "Monedas acumuladas (cuenta PAPO)",
  "admin.commissionsRate": "Tasa de comisión",
  "stickers.amazigh_dancer": "Bailarina amazigh",
  "stickers.mint_tea": "Té con hierbabuena",
  "stickers.gnawa": "Músico gnawa",
  "stickers.afro_pick": "Peine afro",
  "stickers.boombox": "Breakdance",
  "stickers.jazz": "Jazz",
  "stickers.steelpan": "Steelpan",
  "stickers.carnival": "Carnaval",
  "stickers.reggae_lion": "León reggae",
  "stickers.capoeira": "Capoeira",
  "stickers.conga": "Conga",
  "stickers.palenquera": "Palenquera",
  "stickers.didgeridoo": "Didgeridoo",
  "stickers.kangaroo": "Canguro dot-art",
  "stickers.group.moor": "África mora y amazigh",
  "stickers.group.afroamerican": "Afroamericano",
  "stickers.group.afrocaribbean": "Afrocaribeño",
  "stickers.group.afrolatin": "Afrolatino",
  "stickers.group.aboriginal": "Aborigen australiano",
  "coins.recharge": "Recargar",
  "coins.shopTitle": "Recargar monedas PAPO",
  "coins.shopDesc": "Paga con tu cartera cripto. 1 moneda = 0,01 USD.",
  "coins.fee": "comisión",
  "coins.commissionNote": "Cada compra incluye una comisión del 0,99% para PAPO.",
  "coins.bought": "¡+{n} monedas añadidas!",
  "coins.insufficientCrypto": "Saldo {sym} insuficiente en tu cartera",
  "gifts.topGifters": "Top regaladores",
  "sched.addCalendar": "Añadir al calendario",
  "admin.commissionsDaily": "Comisiones por día",
  "admin.source.live_gift": "Regalo en directo",
  "admin.source.coin_purchase": "Compra de monedas",
  "stickers.tabEmojis": "Emojis",
  "stickers.tabAfro": "Emojis Afro",
  "stickers.tabDiaspora": "Diáspora",
  "stickers.recent": "Recientes",
  "stickers.popular": "Populares animados",
  "admin.commissionsCrypto": "Comisiones en cripto",
  "admin.coinReserve": "Reserva por venta de monedas",
  "coins.walletBalance": "Saldo en cartera",
  "admin.commissionsCount": "Comisiones registradas",
  "stickers.kwanzaa": "Kwanzaa",
  "stickers.samba": "Samba de Carnaval",
  "stickers.yennayer": "Yennayer",
  "stickers.juneteenth": "Juneteenth",
  "stickers.elephant": "Elefante",
  "stickers.giraffe": "Jirafa",
  "stickers.zebra": "Cebra",
  "stickers.hippo": "Hipopótamo",
  "stickers.jollof": "Arroz jollof",
  "stickers.feijoada": "Feijoada",
  "stickers.ackee": "Ackee y bacalao",
  "stickers.tagine": "Tajín",
  "stickers.premium": "Packs premium",
  "stickers.unlock": "Desbloquear",
  "stickers.unlocked": "¡Pack desbloqueado! Saldo: {balance} monedas",
  "stickers.pack.fiestas": "Fiestas de la diáspora",
  "stickers.pack.fauna": "Animales de África",
  "stickers.pack.sabores": "Comida tradicional",
  "badges.rank1": "Top 1 regalador",
  "badges.rank2": "Top 2 regalador",
  "badges.rank3": "Top 3 regalador",
  "badges.inProgress": "en curso",
  "badges.tooltip": "Puesto {rank} del mes · {coins} monedas regaladas",
  "badges.leaderboard": "Top regaladores del mes",
  "payment.checking": "Confirmando tu pago…",
  "payment.success": "¡Pago completado!",
  "payment.cancelled": "Pago cancelado",
  "payment.error": "No pudimos confirmar el pago",
  "payment.coinsAdded": "Tus monedas PAPO ya están en tu saldo",
  "payment.back": "Volver a Lives",
  "coins.payCard": "Tarjeta",
  "coins.total": "Total",
  "admin.source.sticker_pack": "Pack de stickers",
  "admin.source.coin_purchase_card": "Compra de monedas (tarjeta)",
  "admin.usdCard": "USD (tarjeta)",
  "admin.commissionsByCurrency": "Comisiones por moneda",
  "coins.shopDescCard": "Paga con tarjeta de forma segura con Stripe. 1 moneda = 0,01 USD.",
  "reset.forgotLink": "¿Olvidaste tu contraseña?",
  "reset.forgotTitle": "Recupera tu cuenta",
  "reset.forgotSubtitle": "Escribe tu email y te enviaremos un enlace para elegir una nueva contraseña.",
  "reset.sendLink": "Enviar enlace",
  "reset.sent": "Si el email está registrado, recibirás un enlace en unos minutos. Revisa también la carpeta de spam. El enlace caduca en 1 hora.",
  "reset.resetTitle": "Nueva contraseña",
  "reset.resetSubtitle": "Elige una contraseña de al menos 8 caracteres.",
  "reset.newPassword": "Nueva contraseña",
  "reset.confirmPassword": "Repite la contraseña",
  "reset.save": "Guardar contraseña",
  "reset.done": "Contraseña actualizada. Ya puedes iniciar sesión.",
  "reset.invalid": "Este enlace no es válido o ha caducado.",
  "reset.requestNew": "Pedir un enlace nuevo",
  "reset.tooShort": "Mínimo 8 caracteres",
  "reset.mismatch": "Las contraseñas no coinciden",
  "reset.adminLink": "Enlace de reinicio",
  "reset.linkCopied": "Enlace copiado (válido 1 hora). Envíaselo al usuario.",
  "auth.tooManyAttempts": "Demasiados intentos. Espera 15 minutos.",
  "authToggle.login": "Iniciar sesión",
  "authToggle.register": "Registrarse",
  "authToggle.label": "Acceso a PAPO",
  "download.title": "Descarga PAPO",
  "download.desc": "Instala la app en tu móvil: gratis, ligera y sin tiendas.",
  "download.android": "Descargar para Android",
  "download.ios": "Descargar para iPhone",
  "download.installed": "PAPO ya está instalada en este dispositivo.",
  "download.androidTitle": "Instalar en Android",
  "download.iosTitle": "Instalar en iPhone / iPad",
  "download.android1": "Abre esta página en Chrome.",
  "download.android2": "Toca el menú ⋮ (arriba a la derecha).",
  "download.android3": "Elige «Instalar aplicación» o «Añadir a pantalla de inicio».",
  "download.ios1": "Abre esta página en Safari.",
  "download.ios2": "Toca el botón Compartir (cuadrado con flecha hacia arriba).",
  "download.ios3": "Elige «Añadir a pantalla de inicio» y pulsa «Añadir».",
  "download.done": "Entendido",
  "videoCall.speaker": "Altavoz",
  "videoCall.mic": "Micrófono",
  "videoCall.camera": "Cámara",
  "videoCall.hangup": "Colgar",
  "emojiCat.afro": "África y Angola",
  "emojiCat.afro-unity": "Unidad y Resistencia",
  "emojiCat.afro-nature": "Naturaleza Africana",
  "emojiCat.afro-food": "Sabores de Angola",
  "emojiCat.happy": "Felices",
  "emojiCat.love": "Amor",
  "emojiCat.gesture": "Gestos",
  "emojiCat.hearts": "Corazones",
  "emojiCat.celebration": "Celebración",
  "emojiCat.nature": "Naturaleza",
  "videoCall.incoming": "Videollamada entrante...",
  "video.processing": "Optimizando vídeo… (puede tardar un poco)",
  "video.processingShort": "Optimizando…",
  "video.trimmedStory": "Tu vídeo se recortó a 2 minutos para la historia",
  "video.trimmedPost": "Tu vídeo se recortó a 10 minutos",
  "video.failed": "No se pudo procesar el vídeo",
  "videoCall.switchCamera": "Girar",
  "stories.maxSize": "Máximo 500MB",
  "reactions.title": "Reacciones",
  "reactions.all": "Todas",
  "reactions.remove": "Quitar mi reacción",
  "reactions.you": "Tú",
  "iosPush.installTitle": "Recibe notificaciones en tu iPhone",
  "iosPush.step1": "Toca el botón Compartir de Safari",
  "iosPush.step2": "Elige «Añadir a pantalla de inicio»",
  "iosPush.step3": "Abre PAPO desde el icono y activa las notificaciones",
  "iosPush.activateTitle": "Activa las notificaciones",
  "iosPush.activateDesc": "Entérate al instante de mensajes, amigos y eventos.",
  "iosPush.activate": "Activar notificaciones",
  "iosPush.later": "Más tarde",
  "groups.backToGroups": "Volver a grupos",
  "groups.aboutGroup": "Sobre este grupo",
  "download.safari1": "Toca el botón Compartir (cuadrado con flecha ⬆) en la barra de Safari, abajo.",
  "download.safari2": "Desliza hacia abajo y elige «Añadir a pantalla de inicio».",
  "download.safari3": "Pulsa «Añadir»: el icono de PAPO aparecerá en tu pantalla de inicio.",
  "download.chrome1": "Toca el botón Compartir (cuadrado con flecha ⬆) arriba a la derecha, junto a la dirección.",
  "download.chrome2": "Elige «Añadir a pantalla de inicio» (si no aparece, desliza la lista).",
  "download.chrome3": "Pulsa «Añadir»: el icono de PAPO aparecerá en tu pantalla de inicio.",
  "download.firefox1": "Toca el menú ☰ abajo a la derecha.",
  "download.firefox2": "Elige «Compartir» y luego «Añadir a pantalla de inicio».",
  "download.firefox3": "Pulsa «Añadir»: el icono de PAPO aparecerá en tu pantalla de inicio.",
  "download.iosNote": "Apple no permite instalar webs con un solo botón: se hace desde el menú Compartir.",
  "download.copyLink": "Copiar enlace",
  "download.linkCopied": "Enlace copiado",
  "download.arrowHint": "Compartir está aquí",
  "download.animCopy": "Copiar",
  "download.animAdd": "Añadir a pantalla de inicio",
  "download.animStep1": "1 · Toca Compartir",
  "download.animStep2": "2 · «Añadir a pantalla de inicio»",
  "download.animStep3": "3 · ¡PAPO ya está en tu iPhone!",
  "reply.reply": "Responder",
  "reply.replyingTo": "Respondiendo a",
  "reply.cancel": "Cancelar respuesta",
  "emailPrivacy.show": "Mostrar mi email a todos",
  "emailPrivacy.hide": "Ocultar mi email",
  "emailPrivacy.nowVisible": "Tu email ahora es visible para todos",
  "emailPrivacy.nowHidden": "Tu email está oculto",
  "emailPrivacy.publicLabel": "Público",
  "emailPrivacy.hiddenLabel": "Oculto",
  "audience.public": "Público",
  "audience.friends": "Amigos",
  "audience.private": "Solo yo",
  "audience.onlyMe": "Solo tú",
  "audience.who": "¿Quién puede verlo?",
  "audience.saved": "Privacidad actualizada",
  "privacyPanel.title": "Quién ve tus datos",
  "privacyPanel.desc": "Resumen de lo que ve cada persona: el público, tus amigos y solo tú.",
  "privacyPanel.data": "Dato",
  "privacyPanel.nameBio": "Nombre, foto y bio",
  "privacyPanel.email": "Email",
  "privacyPanel.phone": "Teléfono",
  "privacyPanel.birthdate": "Fecha de nacimiento",
  "privacyPanel.notSet": "Aún no añadido (Editar perfil)",
  "privacyPanel.emailHint": "El email se muestra u oculta con el icono del ojo en tu perfil o con el interruptor de abajo.",
  "profile.phoneLabel": "Teléfono",
  "profile.birthdateLabel": "Fecha de nacimiento",
  "profile.personalHint": "Opcionales. Por defecto solo los ves tú; elige quién puede verlos con el icono del ojo en tu perfil.",
  "embed.play": "Reproducir vídeo de",
  "embed.openIn": "Abrir en",
};
